export default __webpack_public_path__ + "static/media/changePasswordLogo.64c06478.svg";